import type { AuthState } from '@/features/authentication/types';
import { configureAuthSession, initializeAuthSession } from '@/shared/lib/authSession';
import { create } from 'zustand';

/**
 * Public session state for React. Tokens and provider-specific refresh state remain private to
 * the auth-session coordinator; roles and authorization remain server-side.
 */
export const useAuthStore = create<AuthState>((set) => ({
  status: 'loading',
  source: 'firebase',
  user: null,
  setSession: (session) => set(session),
}));

/**
 * Connects the process-level auth coordinator to the public React snapshot before startup.
 * Idempotent for React StrictMode and independent from application routes after startup.
 */
export function initAuth(): void {
  configureAuthSession({
    getSnapshot: () => useAuthStore.getState(),
    publish: (session) => useAuthStore.getState().setSession(session),
  });
  void initializeAuthSession();
}
